import { render, staticRenderFns } from "./ReservationUpdatedPlan.vue?vue&type=template&id=2e609e28"
import script from "./ReservationUpdatedPlan.vue?vue&type=script&lang=js"
export * from "./ReservationUpdatedPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports